// Тарифы услуги: вариант (на всех языках сайта) + цена строкой.
// value — [{ label: { en, ru, kk }, price: "20 000 ₸" }, ...], onChange(newArray).
const LANGS = [
  { code: "ru", label: "Русский" },
  { code: "en", label: "English" },
  { code: "kk", label: "Қазақша" },
];

const INPUT_CLS =
  "w-full rounded-md border-0 py-1.5 px-3 text-neutral-900 ring-1 ring-inset ring-neutral-300 placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm";

export default function PriceOptionsInput({
  value = [],
  onChange,
  note = {},
  onNoteChange,
}) {
  const setLabel = (index, lang, text) =>
    onChange(
      value.map((item, i) =>
        i === index ? { ...item, label: { ...item.label, [lang]: text } } : item
      )
    );

  const setPrice = (index, price) =>
    onChange(value.map((item, i) => (i === index ? { ...item, price } : item)));

  const add = () =>
    onChange([...value, { label: { ru: "", en: "", kk: "" }, price: "" }]);

  const removeAt = (index) => onChange(value.filter((_, i) => i !== index));

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <div className="block text-base font-medium text-neutral-700">
          Тарифы {value.length > 0 ? `(${value.length})` : ""}
        </div>
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-500"
        >
          Добавить тариф
        </button>
      </div>
      <p className="text-sm text-neutral-500 mb-3">
        Варианты с разной ценой: класс авто, состав сопровождения и т.д.
        Поле «Цена» вверху формы — короткая цена «от…» для верха карточки.
      </p>

      {value.length === 0 ? (
        <div className="text-sm text-neutral-400 border border-dashed border-neutral-300 rounded-lg py-6 text-center">
          Тарифов пока нет
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {value.map((item, index) => (
            <div key={index} className="rounded-lg border border-neutral-200 p-3">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-neutral-500">{`Тариф № ${index + 1}`}</span>
                <button
                  type="button"
                  onClick={() => removeAt(index)}
                  className="text-sm text-red-600 hover:text-red-500"
                >
                  Удалить
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                {LANGS.map((l) => (
                  <div key={l.code}>
                    <span className="block text-xs text-neutral-400 mb-0.5">
                      {l.label}
                    </span>
                    <input
                      type="text"
                      className={INPUT_CLS}
                      value={item?.label?.[l.code] || ""}
                      onChange={(e) => setLabel(index, l.code, e.target.value)}
                    />
                  </div>
                ))}
              </div>
              <div className="mt-2 max-w-xs">
                <span className="block text-xs text-neutral-400 mb-0.5">
                  Цена
                </span>
                <input
                  type="text"
                  className={INPUT_CLS}
                  placeholder="20 000 ₸"
                  value={item?.price || ""}
                  onChange={(e) => setPrice(index, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-4">
        <div className="block text-sm font-medium text-neutral-700 mb-1">
          Примечание под тарифами
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {LANGS.map((l) => (
            <div key={l.code}>
              <span className="block text-xs text-neutral-400 mb-0.5">
                {l.label}
              </span>
              <textarea
                rows={2}
                className={INPUT_CLS}
                value={note?.[l.code] || ""}
                onChange={(e) =>
                  onNoteChange({ ...note, [l.code]: e.target.value })
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
